import React, { useEffect, useState } from 'react';
import { BiChevronDown, BiChevronUp, BiPlus, BiPlusCircle, BiTrash } from 'react-icons/bi';
import { Button } from '../../ui';
import { useBuilderEditor } from '../../../features/builder/BuilderEditorContext';

const RadioGridEditor = () => {
  const {
    gridData, handleColumnChange, addRowOrColumn, removeRowOrColumn,
    addRowSet, removeRowSet, handleRowSetChange, handleRowChange,
  } = useBuilderEditor();
  const [expandedSets, setExpandedSets] = useState([]);

  useEffect(() => {
    setExpandedSets((prev) => {
      if (prev.length === gridData.rowSets.length) return prev;
      if (prev.length < gridData.rowSets.length) {
        return [...prev, ...Array(gridData.rowSets.length - prev.length).fill(true)];
      }
      return prev.slice(0, gridData.rowSets.length);
    });
  }, [gridData.rowSets.length]);

  const toggleRowSet = (setIndex) => {
    setExpandedSets((prev) => {
      const next = [...prev];
      next[setIndex] = !next[setIndex];
      return next;
    });
  };

  return (
    <div className="radio-grid-editor">
      <label className="builder-label">Columns</label>
      <Button variant="ghost" size="sm" icon={<BiPlus />} onClick={addRowOrColumn}>Add columns</Button>

      {gridData.columns.length > 0 && (

        <div className="radio-grid-editor__columns">
          {gridData.columns.map((col, index) => (
            <div key={index} className="radio-grid-editor__column-row">
              <input
                className="builder-ui-input"
                value={col.name || ''}
                onChange={(e) => handleColumnChange(index, e.target.value)}
                placeholder={`Column ${index + 1}`}
                required
              />
              <Button variant="ghost" icon={<BiPlusCircle />} aria-label="Add column" onClick={addRowOrColumn} />
              <Button variant="ghost" icon={<BiTrash />} aria-label="Remove column" onClick={() => removeRowOrColumn(index)} />
            </div>
          ))}
        </div>
      )}

      <div className="builder-span">Create Row Sets</div>

      {gridData.rowSets.map((set, setIndex) => {
        const isExpanded = expandedSets[setIndex] !== false;

        return (

          <div
            key={setIndex}
            className={`radio-grid-editor__row-set${isExpanded ? '' : ' radio-grid-editor__row-set--collapsed'}`}
          >
            <div className="radio-grid-editor__row-set-header">
              <div className="radio-grid-editor__row-set-header-start">
                <Button
                  variant="ghost"
                  size="sm"
                  icon={isExpanded ? <BiChevronUp /> : <BiChevronDown />}
                  aria-label={isExpanded ? 'Collapse row set' : 'Expand row set'}
                  aria-expanded={isExpanded}
                  onClick={() => toggleRowSet(setIndex)}
                />
                <span className="builder-span radio-grid-editor__row-set-title">
                  Row set {setIndex + 1}
                  {set.name ? `: ${set.name}` : ''}
                </span>
              </div>
              <Button variant="ghost" size="sm" icon={<BiTrash />} onClick={() => removeRowSet(setIndex)} aria-label="Remove row set" />
            </div>
            <div className="radio-grid-editor__row-set-body">
              <div className="radio-grid-editor__row-set-fields">
                <div>
                  <label className="builder-label">Name</label>
                  <input className="builder-ui-input" placeholder="Name" value={set.name || ''} onChange={(e) => handleRowSetChange(setIndex, 'name', e.target.value)} />
                </div>
                <div>
                  <label className="builder-label">Code</label>
                  <input className="builder-ui-input" placeholder="Code" value={set.code || ''} onChange={(e) => handleRowSetChange(setIndex, 'code', e.target.value)} />
                </div>
                <div>
                  <label className="builder-label">Help text</label>
                  <input className="builder-ui-input" placeholder="Help text" value={set.help || ''} onChange={(e) => handleRowSetChange(setIndex, 'help', e.target.value)} />
                </div>
                <div>
                  <label className="builder-label">Sort order</label>
                  <input
                    className="builder-ui-input"
                    type="number"
                    min="1"
                    placeholder="Sort order"
                    value={set.sortOrder || ''}
                    onChange={(e) => handleRowSetChange(setIndex, 'sortOrder', Math.max(1, Number(e.target.value)))}
                  />
                </div>
              </div>
              {set.rows?.map((row, rowIndex) => (
                <div key={rowIndex} className="radio-grid-editor__row-option">
                  <div>
                    {rowIndex === 0 && <label className="builder-label">Option</label>}
                    <input
                      className="builder-ui-input"
                      placeholder="Option"
                      value={row.option || ''}
                      onChange={(e) => handleRowChange(setIndex, rowIndex, 'option', e.target.value)}
                    />
                  </div>
                  <div>
                    {rowIndex === 0 && <label className="builder-label">Score</label>}
                    <input
                      className="builder-ui-input"
                      type="number"
                      min="0"
                      placeholder="Score"
                      value={row.score ?? ''}
                      onChange={(e) => handleRowChange(setIndex, rowIndex, 'score', Math.max(0, Number(e.target.value)))}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

        );
      })}
      <Button
        variant="ghost"
        size="sm"
        icon={<BiPlus />}
        onClick={addRowSet}
        disabled={gridData.columns.length === 0}
      >
        Add rows
      </Button>
    </div>
  );
};

export default RadioGridEditor;
